import { Center, Container, Skeleton, VStack } from '@chakra-ui/react';

const MarketplacePrelistLoadingSkeleton = () => (
  <Container maxW="container.xl" my="20px" px={{ base: '16px', md: '24px' }}>
    <VStack spacing={2} align="center" mb={6}>
      <Skeleton h="32px" w="220px" borderRadius="8px" />
      <Skeleton h="16px" w="340px" borderRadius="6px" />
    </VStack>
    <Center>
      <VStack spacing="10px" align="stretch" w="600px" maxW="100%">
        <Skeleton h="120px" borderRadius="15px" />
        <Skeleton h="80px" borderRadius="15px" />
        <Skeleton h="80px" borderRadius="15px" />
      </VStack>
    </Center>
  </Container>
);

export default MarketplacePrelistLoadingSkeleton;
